import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/bernoulli/cdf';
import __var_2__ from '@stdlib/stats/base/dists/bernoulli/ctor';
import __var_3__ from '@stdlib/stats/base/dists/bernoulli/entropy';
import __var_4__ from '@stdlib/stats/base/dists/bernoulli/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/bernoulli/mean';
import __var_6__ from '@stdlib/stats/base/dists/bernoulli/median';
import __var_7__ from '@stdlib/stats/base/dists/bernoulli/mgf';
import __var_8__ from '@stdlib/stats/base/dists/bernoulli/mode';
import __var_9__ from '@stdlib/stats/base/dists/bernoulli/pmf';
import __var_10__ from '@stdlib/stats/base/dists/bernoulli/quantile';
import __var_11__ from '@stdlib/stats/base/dists/bernoulli/skewness';
import __var_12__ from '@stdlib/stats/base/dists/bernoulli/stdev';
import __var_13__ from '@stdlib/stats/base/dists/bernoulli/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace bernoulli
*/
var bernoulli = {};

/**
* @name cdf
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/cdf}
*/
setReadOnly( bernoulli, 'cdf', __var_1__);

/**
* @name Bernoulli
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/ctor}
*/
setReadOnly( bernoulli, 'Bernoulli', __var_2__);

/**
* @name entropy
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/entropy}
*/
setReadOnly( bernoulli, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/kurtosis}
*/
setReadOnly( bernoulli, 'kurtosis', __var_4__);

/**
* @name mean
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/mean}
*/
setReadOnly( bernoulli, 'mean', __var_5__);

/**
* @name median
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/median}
*/
setReadOnly( bernoulli, 'median', __var_6__);

/**
* @name mgf
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/mgf}
*/
setReadOnly( bernoulli, 'mgf', __var_7__);

/**
* @name mode
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/mode}
*/
setReadOnly( bernoulli, 'mode', __var_8__);

/**
* @name pmf
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/pmf}
*/
setReadOnly( bernoulli, 'pmf', __var_9__);

/**
* @name quantile
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/quantile}
*/
setReadOnly( bernoulli, 'quantile', __var_10__);

/**
* @name skewness
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/skewness}
*/
setReadOnly( bernoulli, 'skewness', __var_11__);

/**
* @name stdev
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/stdev}
*/
setReadOnly( bernoulli, 'stdev', __var_12__);

/**
* @name variance
* @memberof bernoulli
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/bernoulli/variance}
*/
setReadOnly( bernoulli, 'variance', __var_13__);


// EXPORTS //
export default bernoulli;

export { __var_1__ as cdf, __var_2__ as Bernoulli, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as mean, __var_6__ as median, __var_7__ as mgf, __var_8__ as mode, __var_9__ as pmf, __var_10__ as quantile, __var_11__ as skewness, __var_12__ as stdev, __var_13__ as variance};